export default function(request, reject, rootAddress) {
  var service = {};
  /**
		获得活动、预约、购买和组队状态
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/groupbuying260902/get_config

	响应示例:
	 {"code":1,"status":1,"msg":"","message":"","data":{"account":"abc***xyz","bind_gold":350000,"buy_status":1,"reserve_status":1,"server_name":"生态服","team":{"button_status":"create_team","team_id":""},"total_activate":1,"v_exp_time_status":0}}
        */
  service.getConfig = function() {
    return request.jsonp(rootAddress + '/jxsj/groupbuying260902/get_config', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "account": "脱敏后的当前账号",
            "bind_gold": "当前账号可领取的绑金",
            "buy_status": "特惠购买时段状态（1：开放，0：关闭）",
            "reserve_status": "预约状态（1：已预约，0：未预约）",
            "server_name": "新服名称",
            "team": "当前账号的组队状态",
            "total_activate": "展示的预约人数",
            "v_exp_time_status": "补买时段状态（1：开放，0：关闭）"
          }
        }
        */
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20104",
        "description": "账号信息不存在"
      }]
        */
      return reject(response);
    });
  };
  /**
		获得九种预购礼包及当前账号购买状态
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/groupbuying260902/gift_list

	响应示例:
	 {"code":1,"status":1,"msg":"","message":"","data":{"gift_list":[{"gift_id":1,"price":18,"v_exp_price":18,"name":"钜惠组队礼包","amount":0,"status":0}],"team":{"button_status":"create_team","team_id":""}}}
        */
  service.giftList = function() {
    return request.jsonp(rootAddress + '/jxsj/groupbuying260902/gift_list', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "gift_list": "礼包列表",
            "team": "当前账号的组队状态"
          },
          "data{}.gift_list[]": {
            "amount": "展示购买人数",
            "gift_id": "礼包编号，1 为双人组队礼包",
            "name": "礼包名称",
            "price": "特惠价",
            "status": "当前账号是否已支付（1：是，0：否）",
            "v_exp_price": "补买价"
          }
        }
        */
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20104",
        "description": "账号信息不存在"
      }]
        */
      return reject(response);
    });
  };
  /**
		获得当前账号绑定手机号
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/groupbuying260902/get_phone

	响应示例:
	 {"code":1,"status":1,"msg":"","message":"","data":{"phone":"13800138000"}}
        */
  service.getPhone = function() {
    return request.jsonp(rootAddress + '/jxsj/groupbuying260902/get_phone', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "phone": "绑定手机号"
          }
        }
        */
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20101",
        "description": "账号没有绑定手机号"
      }, {
        "code": "-20102",
        "description": "账号没有绑定身份证"
      }]
        */
      return reject(response);
    });
  };
  /**
		向当前账号绑定手机号发送验证码
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/groupbuying260902/get_phone_code

	响应示例:
	 {"code":1,"status":1,"msg":"","message":"","data":{}}
        */
  service.getPhoneCode = function(params) {
    return request.jsonp(rootAddress + '/jxsj/groupbuying260902/get_phone_code', params).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        */
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10303",
        "description": "短信内容为空"
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10308",
        "description": "短信验证码发送数量达到每日上限"
      }, {
        "code": "-10309",
        "description": "短信验证码发送频率太快"
      }, {
        "code": "-10316",
        "description": "参数缺失"
      }, {
        "code": "-10317",
        "description": "参数类型错误"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-10601",
        "description": "图片验证码为空"
      }, {
        "code": "-10602",
        "description": "图片验证码错误"
      }, {
        "code": "-10603",
        "description": "极验验证失败"
      }, {
        "code": "-10604",
        "description": "图片验证码参数错误"
      }, {
        "code": "-10605",
        "description": "图片验证码已过期，请重新刷新"
      }, {
        "code": "-10606",
        "description": "顶象验证失败"
      }, {
        "code": "-12304",
        "description": "手机号OpenId参数缺失"
      }, {
        "code": "-20101",
        "description": "账号没有绑定手机号"
      }, {
        "code": "-20102",
        "description": "账号没有绑定身份证"
      }]
        */
      return reject(response);
    });
  };
  /**
		完成身份证和手机验证码校验并预约新服
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/groupbuying260902/activate?id_num=440101199001011234&code=123456

	响应示例:
	 {"code":1,"status":1,"msg":"","message":"","data":{"friends":["好友角色"],"reserve_status":1}}
        */
  service.activate = function(code, id_num) {
    return request.jsonp(rootAddress + '/jxsj/groupbuying260902/activate', {
      code: code /*  手机验证码 */ ,
      id_num: id_num /*  当前账号绑定身份证号码 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "friends": "已预约的好友角色名，最多三名",
            "reserve_status": "预约状态"
          }
        }
        */
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10310",
        "description": "短信验证码不存在"
      }, {
        "code": "-10311",
        "description": "短信验证码为空"
      }, {
        "code": "-10312",
        "description": "短信验证码错误"
      }, {
        "code": "-10313",
        "description": "短信验证码超过有效期"
      }, {
        "code": "-10314",
        "description": "短信验证码已失效"
      }, {
        "code": "-10315",
        "description": "短信验证码已经被验证过，请重新获取"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-11106",
        "description": "没有指定游戏"
      }, {
        "code": "-20101",
        "description": "账号没有绑定手机号"
      }, {
        "code": "-20102",
        "description": "账号没有绑定身份证"
      }, {
        "code": "-20103",
        "description": "绑定身份证验证失败，身份证号不一致"
      }, {
        "code": "-20104",
        "description": "账号信息不存在"
      }, {
        "code": "-20105",
        "description": "该账号已预约"
      }, {
        "code": "-20106",
        "description": "该绑定身份证或绑定手机号已预约其他账号"
      }]
        */
      return reject(response);
    });
  };
  /**
		获得组队信息
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/groupbuying260902/team_config?team_id=4bd318ba837cc98f4a37c68d35f4f92d

	响应示例:
	 {"code":1,"status":1,"msg":"","message":"","data":{"button_status":"join_team","member_count":1,"reserve_status":0,"team_id":"4bd318ba837cc98f4a37c68d35f4f92d"}}
        */
  service.teamConfig = function(team_id) {
    return request.jsonp(rootAddress + '/jxsj/groupbuying260902/team_config', {
      team_id: team_id /*  邀请链接中的队伍 ID，可为空 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "button_status": "create_team/join_team/invite_friend/team_success/team_full/team_unavailable",
            "member_count": "已付款成员数",
            "reserve_status": "当前账号预约状态",
            "team_id": "队伍 ID"
          }
        }
        */
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20104",
        "description": "账号信息不存在"
      }, {
        "code": "-20118",
        "description": "队伍 ID 格式错误"
      }]
        */
      return reject(response);
    });
  };
  /**
		创建礼包支付订单
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/groupbuying260902/create_order?platform=pc&gift_id=1&redirect=https%3A%2F%2Fexample.com

	响应示例:
	 {"code":1,"status":1,"msg":"","message":"","data":{"order_no":"26090212000012345678","pay_url":"https://charge.xoyo.com/game-pay-entrance","team_id":"4bd318ba837cc98f4a37c68d35f4f92d","team_role":"leader"}}
        */
  service.createOrder = function(gift_id, platform, redirect, team_id) {
    return request.jsonp(rootAddress + '/jxsj/groupbuying260902/create_order', {
      gift_id: gift_id /*  礼包编号 */ ,
      platform: platform /*  pc/mobile，默认 pc */ ,
      redirect: redirect /*  支付完成跳转地址，可含 {order_no} */ ,
      team_id: team_id /*  加入组队礼包时必传邀请队伍 ID；队长创建队伍时留空 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "order_no": "订单号",
            "pay_url": "逍遥支付地址",
            "team_id": "组队礼包的队伍 ID",
            "team_role": "leader/member，普通礼包为空"
          }
        }
        */
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20107",
        "description": "不支持的支付平台"
      }, {
        "code": "-20108",
        "description": "购买礼包错误"
      }, {
        "code": "-20109",
        "description": "您已购买该礼包"
      }, {
        "code": "-20110",
        "description": "该订单已支付"
      }, {
        "code": "-20111",
        "description": "订单已存在，请稍后重试"
      }, {
        "code": "-20112",
        "description": "创建订单失败"
      }, {
        "code": "-20117",
        "description": "当前不在礼包购买时间内"
      }, {
        "code": "-20118",
        "description": "队伍 ID 格式错误"
      }, {
        "code": "-20119",
        "description": "队伍不存在或队长尚未完成购买"
      }, {
        "code": "-20120",
        "description": "该队伍已组队成功"
      }, {
        "code": "-20121",
        "description": "队长不能加入自己的队伍"
      }, {
        "code": "-20122",
        "description": "该队伍已有队友正在支付，请稍后再试"
      }, {
        "code": "-20124",
        "description": "组队礼包道具 ID 尚未配置"
      }]
        */
      return reject(response);
    });
  };
  /**
		逍遥支付回调
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/groupbuying260902/callback

	响应示例:
	 {"code":1,"status":1,"msg":"","message":"","data":{"order_no":"26090212000012345678","order_status":1}}
        */
  service.callback = function() {
    return request.jsonp(rootAddress + '/jxsj/groupbuying260902/callback', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "order_no": "订单号",
            "order_status": "支付状态"
          }
        }
        */
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-11106",
        "description": "没有指定游戏"
      }, {
        "code": "-20104",
        "description": "账号信息不存在"
      }, {
        "code": "-20113",
        "description": "支付回调信息异常"
      }, {
        "code": "-20114",
        "description": "签名校验失败"
      }, {
        "code": "-20115",
        "description": "订单 ID 错误"
      }, {
        "code": "-20116",
        "description": "订单未支付"
      }, {
        "code": "-20118",
        "description": "队伍 ID 格式错误"
      }, {
        "code": "-20123",
        "description": "队伍状态异常，请刷新页面重试"
      }]
        */
      return reject(response);
    });
  };
  /**
		非生产环境模拟支付回调
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/groupbuying260902/mock_callback?order_sn=26090212000012345678&order_status=1&vouch_code=test&pay_type=weixin

	响应示例:
	 {"code":1,"status":1,"msg":"","message":"","data":{"order_no":"26090212000012345678","order_status":1}}
        */
  service.mockCallback = function(order_sn, order_status, pay_type, vouch_code) {
    return request.jsonp(rootAddress + '/jxsj/groupbuying260902/mock_callback', {
      order_sn: order_sn /*  订单号 */ ,
      order_status: order_status /*  1 成功，0 失败 */ ,
      pay_type: pay_type /*  支付类型 */ ,
      vouch_code: vouch_code /*  外部订单号 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "order_no": "订单号",
            "order_status": "支付状态"
          }
        }
        */
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-11106",
        "description": "没有指定游戏"
      }, {
        "code": "-20104",
        "description": "账号信息不存在"
      }, {
        "code": "-20115",
        "description": "订单 ID 错误"
      }, {
        "code": "-20118",
        "description": "队伍 ID 格式错误"
      }, {
        "code": "-20123",
        "description": "队伍状态异常，请刷新页面重试"
      }]
        */
      return reject(response);
    });
  };
  /**
		获得所有预约账号角色中财富值前二十名
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/groupbuying260902/show_account_list

	响应示例:
	 {"code":1,"status":1,"msg":"","message":"","data":{"data":[{"role":"角色名","server":"区服名"}]}}
        */
  service.showAccountList = function() {
    return request.jsonp(rootAddress + '/jxsj/groupbuying260902/show_account_list', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "data": "角色列表"
          },
          "data{}.data[]": {
            "role": "角色名",
            "server": "区服名"
          }
        }
        */
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
        */
      return reject(response);
    });
  };
  return service;
}
